export default __webpack_public_path__ + "static/media/c6ac31c21851ca79ab7a614ddcf716d01599842384539.1fbefda2.webp";